/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Video_CallInputs */

const en_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Call`)
};

const es_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videollamada`)
};

const fr_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appel vidéo`)
};

const de_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoanruf`)
};

const ja_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオ通話`)
};

const zh_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频通话`)
};

const ar_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكالمة فيديو`)
};

const id_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panggilan Video`)
};

const it_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videochiamata`)
};

const ru_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеозвонок`)
};

const pt_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chamada de Vídeo`)
};

const ko_val_video_call = /** @type {(inputs: Val_Video_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`화상 통화`)
};

/**
* | output |
* | --- |
* | "Video Call" |
*
* @param {Val_Video_CallInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_video_call = /** @type {((inputs?: Val_Video_CallInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Video_CallInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_video_call(inputs)
	if (locale === "es") return es_val_video_call(inputs)
	if (locale === "fr") return fr_val_video_call(inputs)
	if (locale === "de") return de_val_video_call(inputs)
	if (locale === "ja") return ja_val_video_call(inputs)
	if (locale === "zh") return zh_val_video_call(inputs)
	if (locale === "ar") return ar_val_video_call(inputs)
	if (locale === "id") return id_val_video_call(inputs)
	if (locale === "it") return it_val_video_call(inputs)
	if (locale === "ru") return ru_val_video_call(inputs)
	if (locale === "pt") return pt_val_video_call(inputs)
	return ko_val_video_call(inputs)
});